import "core-js/modules/es.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
export default {
  name: 'mysetting',
  data: function data() {
    return {
      uploadHeader: {
        token: util.cookies.get('token')
      },
      uploadPath: process.env.VUE_APP_API + '/mysetting/wximg',
      form: {
        id: '',
        helpUrl: '',
        wxImg: '',
        toExamine: false
      }
    };
  },
  mounted: function mounted() {
    this.load();
  },
  methods: {
    onsubmit: function onsubmit() {
      try {
        var params = {
          id: this.form.id || '',
          helpUrl: this.form.helpUrl,
          wxImg: this.form.wxImg,
          toExamine: this.form.toExamine ? 1 : 0
        };
        this.$api.saveMySetting(params);
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      } catch (error) {
        this.$message({
          message: '保存失败',
          type: 'warning'
        });
        console.log(error);
      }
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.form.wxImg = res.data;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/jpeg';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }

      return isJPG && isLt2M;
    },
    load: function load() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.getMySetting();

              case 2:
                res = _context.sent;

                if (res != null) {
                  _this.form = res;
                  _this.form.toExamine = Number(res.toExamine) === 1;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};